var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogomob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 66,
    viewBox: "0 0 56 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1067 33.2727L17.8672 16.7711V5.35889L46.1067 22.4945V33.2727Z",
    fill: "#1042F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6525 32.4582L35.7501 27.4382L35.6697 16.1606L26.418 21.6366L26.6525 32.4582Z",
    fill: "#AF49FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2417 55.0481L0 38.5465L9.06069 33.2725L37.3393 50.026L28.2417 55.0481Z",
    fill: "#16EBC3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5235 43.9269L18.6233 38.907V27.814L9.5235 32.8361V43.9269Z",
    fill: "#AF49FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2422 66L37.3398 60.98V49.8892L28.2422 54.9091V66Z",
    fill: "#AF49FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2422 43.7531L37.3398 38.7332V27.6423L28.2422 32.6623V43.7531Z",
    fill: "#AF49FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2417 43.7531L9.52318 32.8159V43.9718L28.2417 54.9091V65.9999L0.00248066 49.4997L0 49.4983V38.4074V27.2515V16.1606L28.2417 32.6623V43.7531Z",
    fill: "#1042F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8672 5.35869L46.1066 22.4943L55.2064 17.1769L26.9278 0L17.8672 5.35869ZM28.2417 32.6624L0 16.1607L9.06069 10.8867L18.5643 16.5178L27.5848 11.2559L35.6684 16.1608L26.8035 21.3997L37.3393 27.6424L28.2417 32.6624Z",
    fill: "#16EBC3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1077 33.2726L55.2074 27.9269V17.177L46.1077 22.4857V33.2726Z",
    fill: "#AF49FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomob);
export default __webpack_public_path__ + "static/media/logomob.107b00d5686bef282ad7d84f03a667eb.svg";
export { ForwardRef as ReactComponent };